export default __webpack_public_path__ + "static/media/edit_icon.b7745aff.svg";